import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import gantsNitrileBleus from "@/assets/products/gants-nitrile-bleus-seul.png";
import gantsNitrileNoirs from "@/assets/products/gants-nitrile-noirs-seul.png";
import gantsVinyle from "@/assets/products/gants-vinyle-seul.png";

const config: ProductPageConfig = {
  name: "Gants jetables",
  breadcrumbName: "Gants",
  subtitle: "Gants nitrile et vinyle non poudrés pour la restauration et l'hygiène",
  features: ["Sans latex", "Non poudré", "Résistant", "Contact alimentaire", "Disponible en stock"],
  variants: [
    {
      name: "Gants nitrile bleus",
      material: "Nitrile",
      color: "Bleu",
      packaging: "Boîte de 100",
      palette: "80 cartons de 10 boîtes",
      image: gantsNitrileBleus,
      availableColors: [
        { name: "Bleu", image: gantsNitrileBleus },
        { name: "Noir", image: gantsNitrileNoirs },
      ],
    },
    {
      name: "Gants nitrile noirs",
      material: "Nitrile",
      color: "Noir",
      packaging: "Boîte de 100",
      palette: "80 cartons de 10 boîtes",
      image: gantsNitrileNoirs,
    },
    {
      name: "Gants vinyle",
      material: "Vinyle",
      color: "Transparent",
      packaging: "Boîte de 100",
      palette: "80 cartons de 10 boîtes",
      image: gantsVinyle,
    },
  ],
};

const Gants = () => <ProductPageLayout config={config} />;
export default Gants;
